export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8759b0807810f986887a24ee74aa930057cb8bba&name=fetchTypeahead!'